import React, { useEffect, useState } from 'react'

import useDebounce from '../Hooks/Debounce';

import SearchBar from '../SearchBar'
import RadioButtonsGroup from '../RadioButtonsGroup';

import IGenericOption from '../../interfaces/IGenericOption';

import styles from './styles.module.scss'

interface IRadioButtonsSearch {
  selected?: IGenericOption | undefined | null;
  setSelected(selected: IGenericOption | undefined): void;
  options: IGenericOption[];
  placeholder: string;
  maxHeight?: number;
  customErrorMsg?: string;
  disabled?: boolean;
  hideSearch?: boolean
}

export default function RadioButtonsSearch({ selected, setSelected, options, placeholder, maxHeight, customErrorMsg, disabled, hideSearch }: IRadioButtonsSearch) {
  const [request, setRequest] = useState("");

  const [searchedOptions, setSearchedOptions] = useState<IGenericOption[]>(options);

  const requestDebounced = useDebounce(request, 400);
  const inputRef = React.useRef<HTMLInputElement>(null);

  // PERFORM SEARCH
  useEffect(() => {
    if (requestDebounced !== "") {
      const foundOptions = options.filter((
        { label }) => label.toLocaleLowerCase().includes(requestDebounced.toLocaleLowerCase()
      ))

      setSearchedOptions(foundOptions.length > 0 ? foundOptions : options);
    }
    else setSearchedOptions(options);
  }, [requestDebounced, options]);

  useEffect(() => {
    if (!!selected && inputRef.current) {
      inputRef.current.blur(); // closing the keyboard
    } 
  }, [selected])

  return (
    <div className={`${styles.searchGroup} ${disabled && styles.disabled}`}>
      { !hideSearch && 
        <SearchBar 
          search={request}
          setSearch={search => setRequest(search)}
          placeholder={placeholder}
          inputRef={inputRef}
        />
      }

      <div className={styles.buttonsHolder}>
        {
          searchedOptions.length > 0 ?
          <RadioButtonsGroup
            selected={selected} 
            options={searchedOptions}
            setSelected={value => { setSelected(value) }}
            maxHeight={maxHeight}
          />
          : 
          <p className={styles.errorMessage}>
            { customErrorMsg ? customErrorMsg
              : "No options found" 
            }
          </p> 
        }
      </div>
    </div>
  )
}